import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';

import type { LanguageItem } from './types';

/** Language options rendered inside the picker popover */
export interface LanguageMenuProps {
  items: LanguageItem[];
  /** Locale code of the active language */
  currentLang: string;
  onSelect: (lang: string) => void;
  className?: string;
}

export const LanguageMenu = ({
  items,
  currentLang,
  onSelect,
  className,
}: LanguageMenuProps) => (
  <div role="menu" className={cn('flex flex-col gap-1', className)}>
    {items.map((item) => {
      const isActive = item.code === currentLang;

      return (
        <button
          key={item.code}
          type="button"
          role="menuitemradio"
          aria-checked={isActive}
          data-language={item.code}
          onClick={() => onSelect(item.code)}
          className={cn(
            'flex cursor-pointer items-center gap-3 rounded-4 border-none px-3 py-2.5',
            isActive ? 'bg-graphic-transparent-brand-10' : 'bg-transparent',
          )}
        >
          <span
            className={cn(
              'flex size-5 shrink-0 items-center justify-center rounded-full border-2',
              isActive ? 'border-action-brand' : 'border-stroke-primary',
            )}
          >
            {isActive && (
              <span className="size-2 rounded-full bg-action-brand" />
            )}
          </span>

          <Typography.Text300Medium
            as="span"
            className="flex-1 text-left text-text-primary"
          >
            {item.label ?? item.title}
          </Typography.Text300Medium>

          <img
            src={item.img}
            alt=""
            className="h-4 w-6 shrink-0 rounded-1 object-cover"
          />
        </button>
      );
    })}
  </div>
);
